import createCache from '@emotion/cache';
import { EmotionCache } from '@emotion/react';
import { NonceUUID } from "./Nonce";

export const EmotionCacheKey: string = "rd-online-emotion";

export const cacheEmotion: EmotionCache = createCache({
    key: EmotionCacheKey,
    nonce: NonceUUID,
});